<script setup>
import { useI18n } from 'vue-i18n';
import Footer from '@/components/landing/Footer.vue';
import LandingPageNavBar from '@/components/navigation/LandingPageNavigationBar.vue';
import PrivacyPolicyList from '@/components/PrivacyPolicyList.vue';

const { t } = useI18n();

const imprints = [
  {
    id: 1,
    title: t('privacyPolicyView.dataProtection.title'),
    content: t('privacyPolicyView.dataProtection.content'),
  },
  {
    id: 2,
    title: t('privacyPolicyView.hostingCDN.title'),
    content: t('privacyPolicyView.hostingCDN.content'),
  },
  {
    id: 3,
    title: t('privacyPolicyView.generalInformation.title'),
    content: t('privacyPolicyView.generalInformation.content'),
  },
  {
    id: 4,
    title: t('privacyPolicyView.recordingData.title'),
    content: t('privacyPolicyView.recordingData.content'),
  },
  {
    id: 5,
    title: t('privacyPolicyView.socialMedia.title'),
    content: t('privacyPolicyView.socialMedia.content'),
  },
  {
    id: 6,
    title: t('privacyPolicyView.analysisTools.title'),
    content: t('privacyPolicyView.analysisTools.content'),
  },
  {
    id: 7,
    title: t('privacyPolicyView.newsletterPrivacyPolicy.title'),
    content: t('privacyPolicyView.newsletterPrivacyPolicy.content'),
  },
  {
    id: 8,
    title: t('privacyPolicyView.pluginsTools.title'),
    content: t('privacyPolicyView.pluginsTools.content'),
  },
  {
    id: 9,
    title: t('privacyPolicyView.eCommerce.title'),
    content: t('privacyPolicyView.eCommerce.content'),
  },
  {
    id: 10,
    title: t('privacyPolicyView.conferenceTools.title'),
    content: t('privacyPolicyView.conferenceTools.content'),
  },
  {
    id: 11,
    title: t('privacyPolicyView.customServices.title'),
    content: t('privacyPolicyView.customServices.content'),
  },
];
</script>

<template>
  <LandingPageNavBar />

  <PrivacyPolicyList
    :title="t('privacyPolicyView.title')"
    :imprints="imprints"
  />

  <Footer />
</template>

<style scoped></style>
